// extracted by mini-css-extract-plugin
export default {"strikeThrough":"strikeThrough__MWYzM","baseCreditPrice":"baseCreditPrice__MmI0M","discountText":"discountText__YTZlZ"};